import React, { ReactNode } from "react"
import { Typography } from "antd"
import reactStringReplace from "react-string-replace"

const replaceUrlsWithLinks = (children: ReactNode): ReactNode => {
  if (typeof children === "string") {
    return reactStringReplace(children, /(https?:\/\/[^\s]+)/g, (match, index) => {
      const isInternalLink = match.includes("vzdelanibudoucnosti.cz")
      const relAttribute = isInternalLink ? undefined : "noopener noreferrer nofollow"

      return (
        <Typography.Link key={`url-${index}`} target="_blank" href={match} rel={relAttribute}>
          {match}
        </Typography.Link>
      )
    })
  } else if (React.isValidElement(children) && children.props.children) {
    return React.cloneElement(children, {
      ...children.props,
      children: replaceUrlsWithLinks(children.props.children)
    })
  } else if (Array.isArray(children)) {
    return React.Children.map(children, (child) => replaceUrlsWithLinks(child))
  }
  return children
}

export default replaceUrlsWithLinks
